import type { SessionUser } from "@restlab/shared";

export function landingPathFor(
  user: Pick<
    SessionUser,
    | "role"
    | "mustChangePassword"
    | "accessScope"
    | "locationIds"
    | "accountType"
  >,
  requestedPath?: string,
) {
  if (user.mustChangePassword) return "/change-password";
  if (user.role === "super_admin") {
    return requestedPath?.startsWith("/admin") ? requestedPath : "/admin";
  }

  if (user.accountType === "standalone") {
    const requestedLocationId = requestedPath?.match(
      /^\/locations\/([^/]+)/,
    )?.[1];
    if (requestedLocationId && user.locationIds.includes(requestedLocationId))
      return requestedPath!;
    return user.locationIds[0]
      ? `/locations/${user.locationIds[0]}/dashboard`
      : "/login";
  }

  if (user.role !== "group_admin") {
    const requestedLocationId = requestedPath?.match(
      /^\/locations\/([^/]+)/,
    )?.[1];
    if (requestedLocationId && user.locationIds.includes(requestedLocationId))
      return requestedPath!;
    return user.locationIds[0]
      ? `/locations/${user.locationIds[0]}/dashboard`
      : "/login";
  }

  return requestedPath && !requestedPath.startsWith("/admin")
    ? requestedPath
    : "/group";
}
